<template>
  <div class="mot-page">

    <!-- Header -->
    <div class="page-header">
      <h1 class="page-title">Mot du Président</h1>
      <div class="page-title-bar"></div>
      <p class="page-subtitle">Message de bienvenue</p>
    </div>

    <v-container class="mot-container">
      <v-row justify="center">
        <v-col cols="12" md="8">

          <v-card elevation="1" rounded="lg" class="letter-card">

            <!-- Opening quote -->
            <div class="quote-banner">
              <v-icon size="28" color="white">mdi-format-quote-open</v-icon>
            </div>

            <div class="letter-body">
              <p class="letter-greeting">
                Bonjour à toutes et à tous, merci de visiter le site de notre association.
                Nous allons bien évidemment répondre aux questions que vous vous posez sur
                <strong>« SELIDAIRE »</strong>.
              </p>

              <p class="letter-para">
                Il est possible de résumer notre raison d'être par la formule suivante :
                il s'agit pour les propriétaires de biens situés au-dessus de la mine
                de mettre en œuvre <strong>« un principe de précaution »</strong>.
              </p>

              <p class="letter-para">
                Nous devons ensemble être en mesure de protéger la valeur de nos biens.
                Les questions les plus fréquentes posées par les habitants
                de <strong>Varangéville</strong> et <strong>Saint Nicolas de Port</strong> sont :
              </p>

              <div class="questions-block">
                <div class="question-item">
                  <v-icon size="16" color="#E65100">mdi-chevron-right</v-icon>
                  Qu'est-ce que SELIDAIRE ?
                </div>
                <div class="question-item">
                  <v-icon size="16" color="#E65100">mdi-chevron-right</v-icon>
                  Pourquoi avoir créé cette association ?
                </div>
                <div class="question-item">
                  <v-icon size="16" color="#E65100">mdi-chevron-right</v-icon>
                  Quels objectifs ?
                </div>
              </div>

              <p class="letter-para">
                Les réponses à ces questions figurent simplement dans les statuts de « SELIDAIRE ».
                Je vous invite donc à lire l'extrait disponible sur ce site. Bonne lecture.
              </p>

              <!-- Signature -->
              <div class="signature-block">
                <div class="signature-line"></div>
                <div class="signature-name">Michel JACQUET</div>
                <div class="signature-role">Président de SELIDAIRE</div>
              </div>
            </div>

          </v-card>

        </v-col>
      </v-row>
    </v-container>

  </div>
</template>

<style scoped>
.mot-page {
  background: #fafafa;
  min-height: 100vh;
}

.page-header {
  padding: 32px 24px 20px;
  background: #ffffff;
  border-bottom: 1px solid #e0e0e0;
  text-align: center;
}

.page-title {
  font-size: 1.4rem;
  font-weight: 700;
  color: #212121;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  margin-bottom: 10px;
}

.page-title-bar {
  width: 40px;
  height: 3px;
  background: #E65100;
  margin: 0 auto 12px;
  border-radius: 2px;
}

.page-subtitle {
  font-size: 0.85rem;
  color: #757575;
  margin: 0;
}

.mot-container {
  max-width: 860px;
  padding-top: 36px;
  padding-bottom: 56px;
}

.letter-card {
  overflow: hidden;
}

.quote-banner {
  background: #E65100;
  padding: 16px 24px 12px;
  display: flex;
  align-items: center;
}

.letter-body {
  padding: 28px 36px 32px;
}

.letter-greeting {
  font-size: 0.95rem;
  line-height: 1.9;
  color: #424242;
  margin-bottom: 20px;
  text-align: justify;
}

.letter-para {
  font-size: 0.9rem;
  line-height: 1.9;
  color: #555;
  margin-bottom: 18px;
  text-align: justify;
}

.questions-block {
  background: #FFF3E0;
  border-left: 4px solid #E65100;
  border-radius: 6px;
  padding: 16px 20px;
  margin: 20px 0 24px;
}

.question-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.88rem;
  font-weight: 600;
  color: #212121;
  padding: 4px 0;
}

.signature-block {
  margin-top: 32px;
  text-align: right;
}

.signature-line {
  width: 60px;
  height: 2px;
  background: #E65100;
  margin-left: auto;
  margin-bottom: 12px;
  border-radius: 2px;
}

.signature-name {
  font-size: 1rem;
  font-weight: 700;
  color: #212121;
  letter-spacing: 0.03em;
}

.signature-role {
  font-size: 0.78rem;
  color: #E65100;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  margin-top: 2px;
}
</style>
